import React from 'react'
import { ButtonBase, Typography, styled } from '@mui/material'
import { useAtomValue, useSetAtom } from 'jotai'
import { RowCenterY } from '../common/Rows'
import TokenLogo from '../common/TokenLogo'
import { TargetChainAtom, TickerAtom } from '../common/atoms'
import { RECOMMENDED_TICKERS } from '@/constants/token'

const RecommendTokenButton = styled(ButtonBase)`
  padding: 4px 8px;
  border: 1px solid rgba(191, 255, 11, 0.2);
  background: #111303;
  gap: 4px;

  :hover {
    border-color: #bfff0b;
    p {
      opacity: 1;
    }
  }
`

const ButtonLabel = styled(Typography)`
  font-size: 14px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  opacity: 0.5;
`

const RecommendedTokens = ({ mode, onSelect }: { mode: 'btc' | 'evm'; onSelect: () => void }) => {
  const setTicker = useSetAtom(TickerAtom)

  const targetChain = useAtomValue(TargetChainAtom)

  const recommendedTickers = RECOMMENDED_TICKERS?.[targetChain]

  return (
    <RowCenterY sx={{ gap: 12 }}>
      {recommendedTickers.map((ticker) => (
        <RecommendTokenButton
          key={ticker.erc20Tokens?.[targetChain].symbol}
          onClick={() => {
            setTicker(ticker.name)
            onSelect()
          }}
        >
          <TokenLogo
            alt={ticker.erc20Tokens?.[targetChain].symbol}
            src={mode === 'evm' && ticker.logoSrcSet?.erc ? ticker.logoSrcSet.erc : ticker.logoSrcSet.brc}
            size={16}
          />
          <ButtonLabel>{ticker.erc20Tokens?.[targetChain].symbol}</ButtonLabel>
        </RecommendTokenButton>
      ))}
    </RowCenterY>
  )
}

export default RecommendedTokens
